import React, {Component} from 'react';

import SelectedPhoto from './selected_photo';
import PhotoThumbnail from './photo_thumbnail';

const photos = [
    {
        name: 'Buick',
        imgPath: require('images/brand_ambassadors/photo_selector/photo_selector_buick.jpg'),
    },
    {
        name: 'Coke',
        imgPath: require('images/brand_ambassadors/photo_selector/photo_selector_coke.png'),
    },
    {
        name: 'Craftsman',
        imgPath: require('images/brand_ambassadors/photo_selector/photo_selector_craftsman.png'),
    },
    {
        name: 'Essie',
        imgPath: require('images/brand_ambassadors/photo_selector/photo_selector_essie.png'),
    },
    {
        name: 'Fiji',
        imgPath: require('images/brand_ambassadors/photo_selector/photo_selector_fiji.png'),
    }
]

export default class PhotoSelector extends Component {
    constructor(){
        super();
        this.handleSelect = this.handleSelect.bind(this);
        this.displayPhotoThumbnails = this.displayPhotoThumbnails.bind(this);
        this.state = {
            selectedPhotoIdx: 0
        }
    }

    handleSelect(idx){
        this.setState({
            selectedPhotoIdx: idx
        });
    }

    displayPhotoThumbnails(){
        const {selectedPhotoIdx} = this.state;

        return photos.map((photo, idx) => {
            const isNotActive = selectedPhotoIdx !== idx ? true : false;

            return <PhotoThumbnail
                key={idx}
                photo={photo}
                isNotActive={isNotActive}
                selectPhoto={() => { this.handleSelect(idx) }} />
        });
    }

    render(){
        const {selectedPhotoIdx} = this.state;
        const PhotoThumbnails = this.displayPhotoThumbnails();

        return(
            <div className='photo-selector'>
                <SelectedPhoto photo={photos[selectedPhotoIdx]} />
                {PhotoThumbnails}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/photo_selector/index.js